// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatList {
  width: 100%;
  height: 100%;
  flex-grow: 1;
  overflow: hidden auto;
  border-width: 0 1px 0 1px;
  border-color: var(--bs-border-color);
  border-style: solid;
  /* Hide Chevron Indicators On Bootstrap*/
}
.ChatList .accordion-button::after {
  background-image: initial;
}
.ChatList .accordion-button:not(.collapsed)::after {
  background-image: initial;
}`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/ChatList/styles.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,wCAAA;AACF;AAAE;EACE,yBAAA;AAEJ;AAAE;EACE,yBAAA;AAEJ","sourcesContent":[".ChatList {\n  width: 100%;\n  height: 100%;\n  flex-grow: 1;\n  overflow: hidden auto;\n  border-width: 0 1px 0 1px;\n  border-color: var(--bs-border-color);\n  border-style: solid;\n  /* Hide Chevron Indicators On Bootstrap*/\n  .accordion-button::after {\n    background-image: initial;\n  }\n  .accordion-button:not(.collapsed)::after {\n    background-image: initial;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
